import React from 'react';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import ShownPanelsEnum from '../Enums/ShownPanelsEnum';
import AuthService from '../Services/authService';
import RoleService from '../Services/roleService';
import FigmaButton from './FigmaButton';

class ButtonRow extends React.Component {
  static defaultProps = {
    colors: [],
    labels: [],
    keys: [],
    icons: [],
    roles: [],
    href: [],
    isItCreate: [],
    roleKeys: null,
    onClick: () => {},
    value: ShownPanelsEnum.None,
    disabled: null,
    buttonTypes: [],
    iconPositions: [],
    className: '',
    buttonClassNames: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      active: ShownPanelsEnum.None,
    };
  }

  componentDidMount() {}

  renderButton(
    label,
    key,
    iconName,
    index,
    disabled = false,
    color = ButtonColorsEnum.Common,
    buttonType,
    iconPosition,
    href = '',
    tooltip = '',
    buttonClassName = ''
  ) {
    iconPosition = iconPosition ? iconPosition : iconName ? IconPositionEnum.Left : undefined;
    const button = (
      <FigmaButton
        className={`${buttonClassName}`}
        type={
          buttonType
            ? buttonType
            : iconName
            ? label
              ? ButtonTypeEnum.NormalIconLeft
              : ButtonTypeEnum.NormalIconOnly
            : ButtonTypeEnum.NormalNormal
        }
        label={label}
        color={color}
        iconName={iconName}
        disabled={disabled}
        onClick={() => this.props.onClick(key)}
        iconPosition={iconPosition}
        key={`${key}${index}`}
        tooltip={tooltip}
      />
    );
    if (href !== '') {
      return (
        <a
          href={href}
          target='_blank'
          rel='noopener noreferrer'
          key={`a${key}${index}`}
        >
          {button}
        </a>
      );
    }
    return button;
  }

  render() {
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();
    const buttons = [];
    this.props.keys.forEach((k, index) => {
      let hasPermission = false;
      if (this.props.roleKeys != null && Array.isArray(this.props.roleKeys) && this.props.roleKeys.length > 0) {
        hasPermission =
          this.props.roleKeys[index] === '' ||
          RoleService.CheckUserPermission(
            'ButtonRowButton',
            this.props.roleKeys[index] ? this.props.roleKeys[index] : ''
          );
      } else if (this.props.roles != null && Array.isArray(this.props.roles) && this.props.roles.length > 0) {
        hasPermission =
          this.props.roles[index] === '' || RoleService.CheckUserPermission('ButtonRowButton', this.props.roles[index]);
      } else {
        hasPermission =
          this.props.roles.length === 0 ||
          this.props.roles[index] === 'User' ||
          loggedInUser.roles.includes(this.props.roles[index]);
      }
      if (hasPermission) {
        buttons.push(
          this.renderButton(
            this.props.labels[index],
            k,
            this.props.icons[index],
            index,
            this.props.disabled !== null && this.props.disabled[index],
            this.props.colors[index],
            this.props.buttonTypes[index],
            this.props.iconPositions[index],
            this.props.href[index],
            this.props.tooltips ? this.props.tooltips[index] : '',
            this.props.buttonClassNames[index] ? this.props.buttonClassNames[index] : ''
          )
        );
      }
    });

    return (
      <div className={this.props.className === '' ? 'MenuButtonList' : this.props.className}>
        <div className='m-1 btn-group '>{buttons}</div>
      </div>
    );
  }
}

export default ButtonRow;
